/**
 * KLOKI dárky k nákupu — group properties + fail-open add + 1:1 cart sync.
 * Spec: docs/superpowers/specs/2026-08-21-darky-k-nakupu-design.md
 *
 * Odebrání / změna qty rodiče: atomický /cart/update.js (rodič + dárky najednou),
 * aby drawer nepřekreslil orphan dárky. Sync zůstává jako pojistka.
 */
(function () {
  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function newGroupId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  /**
   * @param {object} mainItem - { id, quantity, properties? }
   * @param {Array<{id:number, choice?:boolean}>} gifts
   * @returns {object[]} items for /cart/add.js
   *
   * Pořadí: nejdřív dárky, hlavní produkt NAKONEC.
   * Shopify řadí cart.items od nejnovějšího → items.first = upsell recommendations.
   */
  function buildItems(mainItem, gifts) {
    var group = newGroupId();
    var qty = mainItem.quantity || 1;
    var giftList = (gifts || []).filter(function (g) { return g && g.id; });
    var items = [];

    // Bez dárků: čistý main (žádné _gift_* properties — jinak by se košík tvářil jako gift group)
    if (!giftList.length) {
      var solo = { id: mainItem.id, quantity: qty };
      if (mainItem.properties && Object.keys(mainItem.properties).length) {
        solo.properties = Object.assign({}, mainItem.properties);
      }
      return [solo];
    }

    giftList.forEach(function (g) {
      var props = {
        _gift_group: group,
        _gift_of: '1',
        _gift_lock: '1'
      };
      if (g.choice) props._gift_choice = '1';
      items.push({ id: g.id, quantity: qty, properties: props });
    });
    var mainProps = Object.assign({}, mainItem.properties || {}, {
      _gift_group: group,
      _has_gifts: '1'
    });
    items.push({
      id: mainItem.id,
      quantity: qty,
      properties: mainProps
    });
    return items;
  }

  function postAdd(items) {
    return fetch(cartUrl() + '/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var err = new Error(data.description || data.message || 'Cart add failed');
          err.status = r.status;
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  /**
   * Add main + gifts. On 422 with gifts present, retry main-only (fail-open).
   */
  function addWithGifts(mainItem, gifts) {
    var items = buildItems(mainItem, gifts);
    if (window.KlokiCart && typeof window.KlokiCart.invalidateCart === 'function') {
      window.KlokiCart.invalidateCart();
    }
    return postAdd(items).catch(function (err) {
      if (err.status === 422 && gifts && gifts.length) {
        var solo = buildItems(mainItem, []);
        // main-only: buildItems dává hlavní produkt jako jediný (a poslední) řádek
        delete solo[solo.length - 1].properties._has_gifts;
        return postAdd(solo);
      }
      throw err;
    }).then(function (data) {
      if (window.KlokiCart && typeof window.KlokiCart.invalidateCart === 'function') {
        window.KlokiCart.invalidateCart();
      }
      return syncFromServer().then(function () { return data; });
    });
  }

  function changeLine(key, quantity) {
    return fetch(cartUrl() + '/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Cart change failed');
        return data;
      });
    });
  }

  function refreshDrawerIfOpen() {
    if (!window.KlokiCart || typeof window.KlokiCart.open !== 'function') return;
    var d = typeof window.KlokiCart.drawer === 'function' ? window.KlokiCart.drawer() : null;
    if (d && d.classList && d.classList.contains('active')) {
      window.KlokiCart.open();
    }
  }

  /**
   * Jedním /cart/update.js nastaví qty rodiče i všech dárků ve skupině.
   * updates klíče = line item key (funguje i s properties).
   */
  var atomicBusy = false;
  function hideGroupRows(group) {
    document.querySelectorAll('.cart-item[data-gift-group]').forEach(function (row) {
      if (row.getAttribute('data-gift-group') === group) {
        row.style.display = 'none';
      }
    });
  }

  function updateGroupQuantity(parentKey, quantity, group) {
    var updates = {};
    updates[parentKey] = quantity;
    document.querySelectorAll('.cart-item[data-gift-group]').forEach(function (row) {
      if (row.getAttribute('data-gift-group') !== group) return;
      if (row.getAttribute('data-gift-of') !== '1') return;
      var key = row.getAttribute('data-line-key');
      if (key) updates[key] = quantity;
    });

    // Okamžitě schovat celou skupinu při odebrání — bez čekání na round-trip
    if (quantity === 0) hideGroupRows(group);

    atomicBusy = true;
    if (window.KlokiCart && typeof window.KlokiCart.invalidateCart === 'function') {
      window.KlokiCart.invalidateCart();
    }
    return fetch(cartUrl() + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Cart update failed');
        return data;
      });
    }).then(function (data) {
      if (window.KlokiCart && typeof window.KlokiCart.invalidateCart === 'function') {
        window.KlokiCart.invalidateCart();
      }
      refreshDrawerIfOpen();
      return data;
    }).catch(function (err) {
      // Při chybě znovu načíst drawer (vrátí skryté řádky)
      refreshDrawerIfOpen();
      throw err;
    }).finally(function () {
      setTimeout(function () { atomicBusy = false; }, 200);
    });
  }

  function parentRowFromEl(el) {
    var row = el && el.closest ? el.closest('.cart-item') : null;
    if (!row) return null;
    var group = row.getAttribute('data-gift-group');
    if (!group) return null;
    if (row.getAttribute('data-gift-of') === '1') return null;
    var key = row.getAttribute('data-line-key');
    if (!key) return null;
    return { row: row, group: group, key: key };
  }

  // Capture: dřív než Dawn CartRemoveButton → updateQuantity(line, 0)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('cart-remove-button');
    if (!btn) return;
    var parent = parentRowFromEl(btn);
    if (!parent) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    updateGroupQuantity(parent.key, 0, parent.group);
  }, true);

  // Capture: změna qty rodiče (input / plus / minus → change na quantity__input)
  document.addEventListener('change', function (e) {
    var input = e.target.closest('.quantity__input');
    if (!input) return;
    var parent = parentRowFromEl(input);
    if (!parent) return;
    e.stopImmediatePropagation();
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    updateGroupQuantity(parent.key, qty, parent.group);
  }, true);

  /**
   * Align gift line quantities to parent qty per _gift_group (pojistka).
   * Idempotent. Returns { cart, changed }.
   */
  function syncCart(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return Promise.resolve({ cart: cart, changed: false });
    }

    var parents = {};
    cart.items.forEach(function (line) {
      var props = line.properties || {};
      var group = props._gift_group;
      if (!group) return;
      if (props._gift_of === '1') return;
      parents[group] = line;
    });

    var updates = [];
    Object.keys(parents).forEach(function (group) {
      var parent = parents[group];
      var want = parent.quantity;
      cart.items.forEach(function (line) {
        var props = line.properties || {};
        if (props._gift_group !== group || props._gift_of !== '1') return;
        if (line.quantity !== want) {
          updates.push({ key: line.key, quantity: want });
        }
      });
    });

    cart.items.forEach(function (line) {
      var props = line.properties || {};
      if (props._gift_of !== '1' || !props._gift_group) return;
      if (!parents[props._gift_group]) {
        updates.push({ key: line.key, quantity: 0 });
      }
    });

    if (!updates.length) return Promise.resolve({ cart: cart, changed: false });

    var chain = Promise.resolve();
    updates.forEach(function (u) {
      chain = chain.then(function () { return changeLine(u.key, u.quantity); });
    });
    return chain.then(function (last) {
      if (window.KlokiCart && typeof window.KlokiCart.invalidateCart === 'function') {
        window.KlokiCart.invalidateCart();
      }
      return { cart: last || cart, changed: true };
    });
  }

  var syncing = false;
  function syncFromServer() {
    if (syncing || atomicBusy) return Promise.resolve(null);
    syncing = true;
    if (window.KlokiCart && typeof window.KlokiCart.invalidateCart === 'function') {
      window.KlokiCart.invalidateCart();
    }
    var fetchCart = (window.KlokiCart && window.KlokiCart.getCart)
      ? window.KlokiCart.getCart(0)
      : fetch(cartUrl() + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    return fetchCart
      .then(function (cart) { return syncCart(cart); })
      .then(function (result) {
        if (result && result.changed) {
          refreshDrawerIfOpen();
        }
        return result ? result.cart : null;
      })
      .catch(function () { return null; })
      .finally(function () { syncing = false; });
  }

  function giftsFromCsv(csv) {
    if (!csv) return [];
    return csv.split(',').filter(Boolean).map(function (part) {
      var pair = part.split(':');
      return { id: parseInt(pair[0], 10), choice: pair[1] === '1' };
    }).filter(function (g) { return g.id; });
  }

  function giftsFromGsDom() {
    var gifts = [];
    document.querySelectorAll('#gs-offer .gs-item[data-variant-id]').forEach(function (el) {
      var vid = parseInt(el.dataset.variantId, 10);
      if (vid) gifts.push({ id: vid, choice: el.dataset.giftChoice === '1' });
    });
    return gifts;
  }

  function resolvePdpGifts(productForm) {
    var fromMf = giftsFromCsv(productForm && productForm.getAttribute('data-kloki-gifts'));
    if (fromMf.length) return fromMf;
    return giftsFromGsDom();
  }

  /**
   * Nativní product-form na PDP: stejné dárky jako GS (metafield → jinak #gs-offer).
   * Nezasahuje do karty kolekce / quick-add modalu (tam řeší featured-collection / light-qa).
   */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var pf = form.closest('product-form');
    if (!pf) return;
    if (pf.closest('quick-add-modal') || pf.closest('.card') || pf.closest('[id^="Slide-"]')) return;

    var gifts = resolvePdpGifts(pf);
    if (!gifts.length) return;

    var idInput = form.querySelector('[name="id"]');
    var mainId = idInput && parseInt(idInput.value, 10);
    if (!mainId) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var submitButton = pf.querySelector('[type="submit"]');
    var spinner = pf.querySelector('.loading-overlay__spinner');
    if (submitButton) {
      if (submitButton.getAttribute('aria-disabled') === 'true') return;
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
    }
    if (spinner) spinner.classList.remove('hidden');

    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!qty || qty < 1) qty = 1;

    var mainItem = { id: mainId, quantity: qty, properties: {} };
    var propInputs = form.querySelectorAll('[name^="properties["]');
    propInputs.forEach(function (input) {
      var m = input.name.match(/^properties\[([^\]]+)\]$/);
      if (m && input.value) mainItem.properties[m[1]] = input.value;
    });
    if (!Object.keys(mainItem.properties).length) delete mainItem.properties;

    addWithGifts(mainItem, gifts)
      .then(function () {
        try {
          if (window.posthog && typeof window.posthog.capture === 'function') {
            window.posthog.capture('add_to_cart', { variant_id: String(mainId), quantity: qty });
          }
        } catch (err) {}

        if (window.KlokiCareUpsell && typeof window.KlokiCareUpsell.afterCartAdd === 'function') {
          return window.KlokiCareUpsell.afterCartAdd({
            source: 'product_form',
            upsellEligible: true,
            triggerVariantId: mainId
          });
        }
        if (window.KlokiCart && typeof window.KlokiCart.open === 'function') {
          window.KlokiCart.open();
        }
      })
      .catch(function (err) {
        console.error('[kloki-gifts] product-form add failed', err);
        var errWrap = pf.querySelector('.product-form__error-message-wrapper');
        var errMsg = pf.querySelector('.product-form__error-message');
        if (errWrap && errMsg) {
          errWrap.hidden = false;
          errMsg.textContent = (err && err.message) || 'Error';
        }
      })
      .finally(function () {
        if (submitButton) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        }
        if (spinner) spinner.classList.add('hidden');
      });
  }, true);

  var origFetch = window.fetch;
  if (typeof origFetch === 'function' && !window.__klokiGiftsFetchPatched) {
    window.__klokiGiftsFetchPatched = true;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      return origFetch.apply(this, arguments).then(function (res) {
        if (!syncing && !atomicBusy && /\/cart\/(change|update|clear)/.test(url) && res.ok) {
          setTimeout(function () { syncFromServer(); }, 80);
        }
        return res;
      });
    };
  }

  window.KlokiGifts = {
    newGroupId: newGroupId,
    buildItems: buildItems,
    addWithGifts: addWithGifts,
    updateGroupQuantity: updateGroupQuantity,
    giftsFromCsv: giftsFromCsv,
    giftsFromGsDom: giftsFromGsDom,
    syncCart: syncCart,
    syncFromServer: syncFromServer
  };
})();
